.level_selector[data-level-selector] {
  float: right;
  position: relative;
  height: 100%;

  button {
    background-color: transparent;
    color: #fff;
    font-family: Roboto, "Open Sans", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    border: none;
    cursor: pointer;
    font-size: 12px;
    height: 100%;
    opacity: 0.7;

    &:hover {
      opacity: 1;
      color: #fff;
    }

    &.changing {
      -webkit-animation: level-selector-pulse 0.5s infinite alternate;
      animation: level-selector-pulse 0.5s infinite alternate;
    }
  }

  > ul {
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 250px;
    margin: 0;
    padding: 0;
    list-style-type: none;
    position: absolute;
    right: 0;
    bottom: 100%;
    display: none;
    background-color: rgba(28, 28, 28, 0.9);
    white-space: nowrap;
  }

  li {
    font-size: 12px;
    color: #eee;

    &[data-title] {
      background-color: #333;
      padding: 8px 25px;
    }

    a {
      color: #eee;
      padding: 5px 18px;
      display: block;
      text-decoration: none;

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
        color: #fff;
        text-decoration: none;
      }
    }

    &.current a {
      color: #2ecc71;
    }
  }
}

@-webkit-keyframes level-selector-pulse {
  0% { color: #fff; }
  50% { color: #ff0101; }
  100% { color: #b80000; }
}

@keyframes level-selector-pulse {
  0% { color: #fff; }
  50% { color: #ff0101; }
  100% { color: #b80000; }
}
